import * as React from "react";
import { Tag } from "antd";
import { Table } from "../../../newcomponents/table/table";
import { GeoRouteEntry } from "../../../reactHooks/useGeoRoute";

const reasonColors: Record<string, string> = {
  geo: "green",
  fallback: "orange",
  health: "red",
  default: "blue",
};

interface Props {
  data: GeoRouteEntry[];
  isLoading: boolean;
}

export const GeoRouteTable: React.FC<Props> = ({ data, isLoading }) => {
  return (
    <Table<GeoRouteEntry>
      tableId="geo-route-table"
      data={data}
      isLoading={isLoading}
      hideSettings
      styles={{ header: { marginBottom: 0 } }}
      columns={[
        { id: "location", label: "Location", enableResize: true, size: 200 },
        { id: "target", label: "Target", enableResize: true, size: 300 },
        {
          id: "reason",
          label: "Reason",
          enableResize: true,
          size: 150,
          cell: ({ getValue }) => {
            const reason = getValue() as string;
            const color = reasonColors[reason] || reasonColors.default;
            return <Tag color={color}>{reason}</Tag>;
          },
        },
        {
          id: "latencyMs",
          label: "Latency (ms)",
          enableResize: true,
          size: 120,
          cell: ({ getValue }) => {
            const value = getValue() as number | null;
            if (value === null) return "-";
            return value % 1 === 0 ? String(value) : value.toFixed(1);
          },
        },
      ]}
    />
  );
};
